import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import logo from 'assets/images/msys.png';

function Footer({ isWhite }) {
  // eslint-disable-next-line no-constant-condition
  if (true) return <div />;

  return (
    <div
      className={cn('sm:text-left flex flex-col text-center', {
        'text-gray-500': !isWhite,
        'text-white': isWhite,
      })}
    >
      <span className="text-xxs">Powered by</span>
      <img className="h-6 w-auto mx-auto sm:-mx-0" src={logo} alt="scorebox" />
      <span className="text-xxs">Version: 2.1</span>
    </div>
  );
}

Footer.defaultProps = {
  isWhite: false,
};

Footer.propTypes = {
  isWhite: PropTypes.bool,
};

export default Footer;
